import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GuiProvider } from '../../providers/gui.provider';
import {buildGermanDate} from "../../util/date-utils";


@Component({
  selector: 'date-input',
  templateUrl: 'date-input.html',
})
export class DateInput {

  @Input() label: string;
  @Input() date: string;
  @Input() direction: string = ""; //back, forward oder ohne Angabe (dann max. 3 Jahre in die Zukunft)
  @Output() dateChange: any = new EventEmitter();

  @ViewChild('dateInput') dateInput : HTMLInputElement;


  constructor(private guiProvider : GuiProvider) {
	}

  onDate(date: string) {
		this.date = buildGermanDate(date, new Date(), this.direction);
    //Text nochmal überschreiben, wenn sich der Wert im Textfeld, aber nicht
    //im Modell geändert hat. z.B. würde die Änderung von "01.01.1999" auf "01.01.99"
    //nicht im Modell als Änderung wahrgenommen werden.
    if (this.date != this.dateInput.value)
      this.dateInput.value = this.date;
    this.dateChange.emit(this.date);
	}

	pickDate(propertyName: string) {
		this.guiProvider.showAlert('Datum', 'TODO: Grafische Datumswahl');
	}

}



// WEBPACK FOOTER //
// ./src/components/date-input/date-input.component.ts